module.exports = __webpack_public_path__ + "img/redeem.51293269.png";